import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const MenuSimpleIcon = memo(({ className, color = colors.basic.black, fontSize }: SvgIconProps) => {
  return (
    <SvgIcon
      className={className}
      style={{ fontSize }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      fontSize="inherit"
    >
      <rect x="24" y="15" width="3" height="19" rx="1.5" transform="rotate(90 21 15)" fill={color} />
      <rect x="24" y="7" width="3" height="19" rx="1.5" transform="rotate(90 21 7)" fill={color} />
    </SvgIcon>
  );
});
